// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-confirm {
  color: #636363;
  width: 325px;
}

.modal-confirm .modal-content {
  padding: 20px;
  border-radius: 5px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-confirm .modal-header {
  border-bottom: none;
  position: relative;
}

.modal-confirm h4 {
  text-align: center;
  font-size: 26px;
  margin: 8px 0;
}

.modal-confirm .form-control,
.modal-confirm .btn {
  min-height: 40px;
  border-radius: 3px;
}

.modal-confirm .close {
  position: absolute;
  top: -5px;
  right: -5px;
}

.modal-confirm .modal-footer {
  border: none;
  text-align: center;
  border-radius: 5px;
  font-size: 13px;
  gap: 7px;
  flex-wrap: unset;
  width: 100%;
}

.modal-confirm .icon-box {
  color: #82ce34;
  margin: 0 auto;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  z-index: 9;
  background: transparent;
  padding: 15px;
  text-align: center;
  border-width: 1px;
  border-style: solid;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-confirm .icon-box i {
  font-size: 30px;
  position: relative;
  top: 3px;
}

.modal-confirm .btn {
  color: #fff;
  border-radius: 4px;
  background: #82ce34;
  text-decoration: none;
  transition: all 0.4s;
  line-height: normal;
  border: none;
}

.modal-confirm .btn:hover,
.modal-confirm .btn:focus {
  background: #6fb32b;
  outline: none;
}

.modal-header {
  display: block;
}

.trigger-btn {
  display: inline-block;
  margin: 100px auto;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/common/modals/payment-reponse/payment-reponse.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AAAA;EACE,mBAAA;EACA,kBAAA;AAGF;;AADA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;AAIF;;AAFA;;EAEE,gBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAMF;;AAJA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AAOF;;AALA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAQF;;AANA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;AASF;;AALA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AAQF;;AANA;;EAEE,mBAAA;EACA,aAAA;AASF;;AAPA;EACE,cAAA;AAUF;;AARA;EACE,qBAAA;EACA,kBAAA;AAWF","sourcesContent":[".modal-confirm {\n  color: #636363;\n  width: 325px;\n}\n.modal-confirm .modal-content {\n  padding: 20px;\n  border-radius: 5px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.modal-confirm .modal-header {\n  border-bottom: none;\n  position: relative;\n}\n.modal-confirm h4 {\n  text-align: center;\n  font-size: 26px;\n  margin: 8px 0;\n}\n.modal-confirm .form-control,\n.modal-confirm .btn {\n  min-height: 40px;\n  border-radius: 3px;\n}\n.modal-confirm .close {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n}\n.modal-confirm .modal-footer {\n  border: none;\n  text-align: center;\n  border-radius: 5px;\n  font-size: 13px;\n  gap: 7px;\n  flex-wrap: unset;\n  width: 100%;\n}\n.modal-confirm .icon-box {\n  color: #82ce34;\n  margin: 0 auto;\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  z-index: 9;\n  background: transparent;\n  padding: 15px;\n  text-align: center;\n  border-width: 1px;\n  border-style: solid;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.modal-confirm .icon-box i {\n  font-size: 30px;\n  position: relative;\n  top: 3px;\n}\n.modal-confirm.modal-dialog {\n}\n.modal-confirm .btn {\n  color: #fff;\n  border-radius: 4px;\n  background: #82ce34;\n  text-decoration: none;\n  transition: all 0.4s;\n  line-height: normal;\n  border: none;\n}\n.modal-confirm .btn:hover,\n.modal-confirm .btn:focus {\n  background: #6fb32b;\n  outline: none;\n}\n.modal-header {\n  display: block;\n}\n.trigger-btn {\n  display: inline-block;\n  margin: 100px auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
